import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Handles applied promo code form.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Targets
 * -------
 *
 * input  - (required) - code input element
 * button - (required) - apply button element
 * flash  - (required) - flash element
 *
 * Usage
 * -------
 *
 * <div data-controller="promo-code">
 *   <input data-promo-code-target="input" />
 *   <button data-promo-code-target="button" />
 *   <div data-promo-code-target="flash" />
 * </div>
 */
export default class default_1 extends Controller {
    static targets = ['input', 'button', 'flash'];
    connect() {
        this.appliedButtonInnerHTML = this.buttonTarget.innerHTML;
        this.appliedCode = this.inputTarget.value;
        this.appliedFlash = this.flashTarget.innerHTML;
    }
    handleInputChange(e) {
        if (e.target instanceof HTMLInputElement && e.target.value === this.appliedCode) {
            this.buttonTarget.innerHTML = this.appliedButtonInnerHTML;
            this.flashTarget.innerHTML = this.appliedFlash;
        }
        else {
            this.buttonTarget.innerHTML = 'Apply';
        }
    }
    handleButtonClick(e) {
        if (this.inputTarget.value === this.appliedCode)
            e.preventDefault();
    }
}
